import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MenuService } from 'src/app/services/menu/menu-service';
import { Constantes } from 'src/app/shared/Constantes/constantes';
import {
  CertificadosFilterModel,
  StatusCertificado,
} from 'src/app/shared/models/CertificadosFilterModel';
import { ComboType } from 'src/app/shared/models/ComboType';
import { Router } from '@angular/router';

@Component({
    selector: 'app-pedidos-pendiente-filtro',
    templateUrl: './pedidos-pendiente-filtro.component.html',
    styleUrls: ['./pedidos-pendiente-filtro.component.css'],
    standalone: false
})
export class PedidosPendienteFiltroComponent implements OnInit {
  @Input() classModal: string = Constantes.classCierreModal;
  @Output() eventoFiltrar = new EventEmitter<CertificadosFilterModel>();
  @Output() refreshData = new EventEmitter<void>();
  @Input() dataObras: ComboType[] = new Array();
  @Input() selectObra: string;
  @Input() selectCodigoObra: string;
  @Input() fechaMinima;
  @Input() fechaMaxima;
  @Input() numberOrders: number = 0;
  @Input() numberOrdersFiltered: number = 0;
  @Input() numberOrdersDelivered: number = 0;
  @Input() numberRejectedOrders: number = 0;
  @Input() numberPendingOrders: number = 0;
  @Input() isStatusFilterEnabled: boolean = false;
  campaignOne: UntypedFormGroup;

  selectNumero: string = '';
  formEdicion: UntypedFormGroup;
  range: UntypedFormGroup;
  statusSelected: number = 0;

  obrasArray: ComboType[];
  @ViewChild('InputSearch', { static: true }) nameSearchElement: ElementRef;
  @ViewChild('contenidoModal') contenidoModal!: TemplateRef<any>;

  dialogRef: MatDialogRef<any>;
 
  constructor(
    private menu: MenuService,
    nameSearchElement: ElementRef,
    private dialog: MatDialog,
    private router: Router
  ) {
    this.nameSearchElement = nameSearchElement;

    this.formEdicion = new UntypedFormGroup({
      numeroBuscar: new UntypedFormControl(this.selectNumero),
    });

    this.range = new UntypedFormGroup({
      start: new UntypedFormControl(),
      end: new UntypedFormControl(),
    });
  }
  get numeroBuscar() {
    return this.formEdicion.get('numeroBuscar');
  }
  ngOnInit(): void {
    this.obrasArray = this.dataObras;
    this.reLoadObrasFilter();
  }

  reLoadObrasFilter() {
    if (this.dataObras.length > 0) {
      this.obrasArray = this.dataObras;
    } else {
      setTimeout(() => {
        this.reLoadObrasFilter();
      }, 100);
    }
  }

  onOpenModal() {
    this.dialogRef = this.dialog.open(this.contenidoModal, {
      maxWidth: '90%', // Puedes ajustar el ancho según tus necesidades
    });
  }

  onCierrenModal() {
    this.dialogRef.close();
  }

  onFiltrar() {
    let dataFiltrar = new CertificadosFilterModel();

    dataFiltrar.numeroFiltar = this.numeroBuscar.value;
    dataFiltrar.fechaDesde = this.range.value.start;
    dataFiltrar.fechaHasta = this.range.value.end;
    dataFiltrar.hasFilter = true;
    dataFiltrar.status = this.getStatus();

    this.eventoFiltrar.emit(dataFiltrar);
    this.onCierrenModal();
  }

  getStatus() {
    switch (this.statusSelected) {
      case 0:
        return StatusCertificado.All;
      case 1:
        return StatusCertificado.Delivered;
      case 3:
        return StatusCertificado.Pending;
      default:
        return StatusCertificado.Rejected;
    }
  }

  onKey(value) {
    this.obrasArray = [];
    this.selectSearch(value);
  }
  selectSearch(value: string) {
    let filter = value.toLowerCase();
    for (let i = 0; i < this.dataObras.length; i++) {
      let option = this.dataObras[i];
      if (
        option.value.toLowerCase().indexOf(filter) >= 0 ||
        option.id.toLowerCase().indexOf(filter) >= 0
      ) {
        this.obrasArray.push(option);
      }
    }
  }

  selectStatus(status: number) {
    this.statusSelected = status;
  }

  clearDate(event) {
    this.range.reset();
    event.stopPropagation();
  }


updateUrl() {
  if (!navigator.onLine) return;
  this.refreshData.emit();
}
}


